<div class="wrapper">

    <!-- Page Content  -->
    <div class="body-wrapper">

       <!-- Main Content  -->
       <div class="main-panel" id="main-content-div">
          <div class="content-wrapper">
            <router-outlet></router-outlet>
          </div>
          
       </div>
    </div>
 </div>